export const licenciaRoutesMap = {
  gestion: {
    path: '/licencia',
    name: 'Licencia de uso',
  },
}
